module.exports = __webpack_public_path__ + "img/empty_img.d11ea678.svg";